import { useState } from "react";
import { Button, Modal } from "antd";
import moment from "moment";
import { Amap, CircleMarker } from "@amap/amap-react";
import StringUtils from "../../../../../../../util/StringUtils";
import TenantDeviceApi from "../../../../../../../api/TenantDeviceApi";
import DeviceStatus, { DeviceStatusUtils } from "../../../../../../../components/ui-components/device-status/DeviceStatus";
import { Content, InfoGroupSeparator, InfoItem, InfoItemRow, InfoLabel, InfoValue, TenantDeviceDetailsWrapper, TenantDeviceMapWrapper, Title, TitleWrapper } from "./TenantDeviceDetails.styled";
import InvokeLockoutModal from "../invoke-lockout-modal/InvokeLockoutModal";

interface TenantDeviceDetailsProps {
    tenantDeviceView: any
}

const TenantDetailDetails: React.FC<TenantDeviceDetailsProps> = (props)=> {
    // api
    let tenantDeviceApi = new TenantDeviceApi();

    // parameters
    let tenantDeviceView = props.tenantDeviceView;
    let mapCenter = tenantDeviceView.tenantNode ? [tenantDeviceView.tenantNode.longitude, tenantDeviceView.tenantNode.latitude] : null;

    // state
    let [openInvokeLockoutModal, setOpenInvokeLockoutModal] = useState<boolean>(false);


    // events
    let onLockoutClick = ()=> {
        setOpenInvokeLockoutModal(true);
    };

    // render
    let formatDate = (date: any)=> {
        if (!date) {
            return 'N/A';
        }
        return moment(Number(date)).format('YYYY/MM/DD HH:mm:ss');
    }

    return (
        <TenantDeviceDetailsWrapper>
            <TitleWrapper>
                <Title>设备详情</Title>
            </TitleWrapper>

            <Content>
                <InfoItemRow>
                    <InfoItem>
                        <InfoLabel>设备名称</InfoLabel>
                        <InfoValue>{StringUtils.emptyToSlash(tenantDeviceView.device?.name)}</InfoValue>
                    </InfoItem>

                    <InfoItem>
                        <InfoLabel>序列号</InfoLabel>
                        <InfoValue>{tenantDeviceView.tenantNode?.sn}</InfoValue>
                    </InfoItem>
                </InfoItemRow>

                <InfoItemRow>
                    <InfoItem>
                        <InfoLabel>租户</InfoLabel>
                        <InfoValue>{StringUtils.emptyToSlash(tenantDeviceView.tenant?.name)}</InfoValue>
                    </InfoItem>
                    <InfoItem>
                        <InfoLabel>ICCID</InfoLabel>
                        <InfoValue>{StringUtils.emptyToSlash(tenantDeviceView.tenantNode?.iccid)}</InfoValue>
                    </InfoItem>
                </InfoItemRow>
                
                <InfoItemRow>
                    <InfoItem>
                        <InfoLabel>LAC</InfoLabel>
                        <InfoValue>{StringUtils.emptyToSlash(tenantDeviceView.tenantNode?.lac)}</InfoValue>
                    </InfoItem>

                    <InfoItem>
                        <InfoLabel>CI</InfoLabel>
                        <InfoValue>{StringUtils.emptyToSlash(tenantDeviceView.tenantNode?.ci)}</InfoValue>
                    </InfoItem>
                </InfoItemRow>

                <InfoItemRow>
                    <InfoItem>
                        <InfoLabel>固件版本</InfoLabel>
                        <InfoValue>{StringUtils.emptyToSlash(tenantDeviceView.tenantNode?.firmwareVersion)}</InfoValue>
                    </InfoItem>

                    <InfoItem>
                        <InfoLabel>最后在线时间</InfoLabel>
                        <InfoValue>{formatDate(tenantDeviceView.tenantNode?.lastSeenTime)}</InfoValue>
                    </InfoItem>
                </InfoItemRow>
                
                <InfoItemRow>
                    <InfoItem>
                        <InfoLabel>设备状态</InfoLabel>
                        <InfoValue><DeviceStatus status={tenantDeviceView.tenantNode?.status} /></InfoValue>
                    </InfoItem>

                    <InfoItem>
                        <InfoLabel>操作</InfoLabel>
                        <InfoValue><a onClick={(e)=> onLockoutClick()}>执行锁机命令</a></InfoValue>
                        <InvokeLockoutModal tenantDeviceView={tenantDeviceView} open={openInvokeLockoutModal} onClose={()=> setOpenInvokeLockoutModal(false)} />
                    </InfoItem>
                </InfoItemRow>

                <InfoGroupSeparator />

                <TenantDeviceMapWrapper>
                    <Amap
                        mapStyle='amap://styles/dark'
                        zoom={4}
                        center={mapCenter}>
                        
                        {
                            mapCenter && (
                                <CircleMarker
                                    center={mapCenter} 
                                    radius={6} 
                                    fillColor={DeviceStatusUtils.getDeviceMarkerColor(tenantDeviceView.tenantNode.status)}
                                    fillOpacity={0.8} 
                                    strokeWeight={0}
                                    cursor="pointer" />
                            )
                        }
                    </Amap>
                </TenantDeviceMapWrapper>
            </Content>
        </TenantDeviceDetailsWrapper>
    )
}

export default TenantDetailDetails;